import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class EmployeesSidebarService {
    private changeEmitter: Subject<void> = new Subject<void>();

    changed(): void {
        this.changeEmitter.next();
    }

    getEmitter(): Observable<void> {
        return this.changeEmitter.asObservable();
    }
}
